import axios from 'axios';
import { UploadImportFileRequest } from '../../../types/interfaces/file/imports';
import { UploadCapturesResponse } from '../../../types/interfaces/file/imports/captures';
import { SessionStore } from '../../../types/store/SessionStore';
import { newAbortSignal } from '../../../utils';

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/captures/upload/validate`;

export const uploadCapturesFile = async (
  uploadInfo: UploadImportFileRequest
): Promise<UploadCapturesResponse> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}"
  );

  const formData = new FormData();
  formData.append('capturesXLSX', uploadInfo.file);
    
  const res = await axios.post<UploadCapturesResponse>(BASE_URL, formData, {
    headers: {
      "content-type": "multipart/form-data",
      "x-access-token": session?.accessToken,
    },
    timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
    signal:
      AbortSignal.timeout === undefined
        ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
        : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
  });

  return res.data;
};